export const API_ENDPOINTS = {
  contact: `/api/formsubmission`,
  career: `/api/formsubmission` 
};
